import type { DocumentContext } from '@ContractBuilder/utils';
import type { ResourceBlock } from '@domain/schemas/contract.schema';
import type { EntityData } from '@domain/types/entity';
import type { BaseUser } from '@helpers/auth/types';
import { canChange } from '@helpers/canChange';
import { isSummaryBlock } from '@root/helpers/blocks';

import { crossCheckBlockUserCtx } from './cross-check-block-user-ctx';
import { blockRulesIsVisible } from '.';

export type BlockRulesIsEditableArgs = {
  block: ResourceBlock;
  context: DocumentContext;
  disableControls: boolean;
  isEndorsementView?: boolean;
  isSummaryBlock?: boolean;
  status: EntityData['status'];
  user: BaseUser | null;
};

export const blockRulesIsEditable = ({
  block,
  context,
  disableControls,
  isEndorsementView,
  status,
  user,
}: BlockRulesIsEditableArgs) => {
  const canEditInEndorsementView = isEndorsementView ? isSummaryBlock(block) : true;

  const documentConditionsAllowChange =
    canChange(status) && canEditInEndorsementView && !disableControls && blockRulesIsVisible(block, context);

  const { canBeEditedWithCurrentPermissions } = crossCheckBlockUserCtx(block, context, user);

  if (!documentConditionsAllowChange || !canBeEditedWithCurrentPermissions) {
    return false;
  }

  return canBeEditedWithCurrentPermissions;
};
